import * as React from "react";

/**
 * Read-only coordinate chip: label and value on one line, as in the design.
 * Shared by the pickup-location card and the onboarding wizard's site step.
 */
export const CoordChip: React.FC<{ label: string; value?: string }> = ({ label, value }) => (
  <div className="flex flex-1 items-center gap-2 rounded-lg bg-slate-100 px-3 py-1.5 text-sm">
    <span className="text-icon-secondary">{label}</span>
    <span className="truncate text-text-body">{value || "—"}</span>
  </div>
);
